import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TenantSettingsModel } from '../model/tenant-settings.model';
import { map } from 'rxjs/operators';

const CONTROLLER = 'tenantSettings';

@Injectable({
  providedIn: 'root',
})
export class TenantSettingsService {

  constructor(private http: HttpClient) {}

  public getTenantSettings(): Observable<TenantSettingsModel> {
    return this.http.get<{ value: TenantSettingsModel }>(`${CONTROLLER}`)
      .pipe(
        map(response => response.value)
      );
  }
}